import $ from 'jquery';
import 'jquery-ui-dist/jquery-ui';
import i18next from 'i18next';

import { deleteCsrfCookie, loadConfig } from '@retail/core';
import { getFeatures, loadRetailFeatureConfig } from '@retail/feature-config';
import { initPolyfills } from '@shared/polyfills';
import { getEnv } from '@luna/env';
import { logger } from '@luna/logger';
import { initRequestsObserver } from '@luna/performance';
import { initSentry, updateBeanCounterConfig, updatePosthogConfig } from '@shared/statistics';
import { ProfileFlags, queryMyProfileIfNeeded } from '@shared/profile';
import { checkAntiClickJack, handleLoginRedirects, shouldLoadMainPage } from '@retail/apps';

function loadGlobals() {
    // @ts-expect-error custom type
    window.$ = $;
    // @ts-expect-error custom type
    window.jQuery = $;
    window.i18 = i18next;
}

export async function startGeorge() {
    performance?.mark?.('start_george');
    try {
        initPolyfills();
        checkAntiClickJack();
        initRequestsObserver();
        await loadConfig();
        loadRetailFeatureConfig();
        getFeatures();
        try {
            initSentry(getEnv());
        } catch (e) {
            logger.error('Init sentry failed', e);
        }
        const isJuniorHandler = async (): Promise<boolean> => {
            const profile = await queryMyProfileIfNeeded();
            return !!profile.flags?.includes(ProfileFlags.JUNIOR);
        };

        updatePosthogConfig({
            dataConsentHandler: async () => {
                const { hasPosthogConsent } = await import('@retail/statistics');
                return hasPosthogConsent();
            },
            isJuniorHandler,
        });

        updateBeanCounterConfig({
            isJuniorHandler,
        });

        await handleLoginRedirects();
        if (shouldLoadMainPage()) {
            deleteCsrfCookie();
            loadGlobals();
            const { startMainPage } = await import(
                './mainpage.main' /* webpackChunkName: "mainpage-main" */
            );
            startMainPage();
        } else {
            logger.debug('Main page wont be loaded');
        }
    } catch (e) {
        logger.error(e);
    }
}

document.addEventListener('DOMContentLoaded', startGeorge);
